import { cerr, clog } from './clog';
import { DataCapsule, LocalStorageStrategy } from '@wix/data-capsule';
import _isEqual from 'lodash/isEqual';

const dataCapsule = new DataCapsule({
  strategy: new LocalStorageStrategy(),
  namespace: 'wix-digor',
});

export interface DIGORState {
  open: boolean;
  searchTerm: string;
  searchResults: string | null;
  savedAt: number;
}

const DIGOR_LS_KEY = 'digor-ai-widget';
const STALE_AFTER = 5 * 60 * 1000; // 5 minutes

export const saveStateToLocalStorage = async ({
  searchResults,
  searchTerm,
  open,
}: {
  searchResults?: string | null;
  searchTerm?: string;
  open?: boolean;
}) => {
  const currentState = await readStateFromLocalStorage<DIGORState>();

  const newState = {
    ...currentState,
    ...(searchResults !== undefined && { searchResults }),
    ...(searchTerm !== undefined && { searchTerm }),
    ...(open !== undefined && { open }),
  };

  if (_isEqual(currentState, newState)) {
    return;
  }

  newState.savedAt = Date.now();

  clog('digor-wrapper: saving-state');

  // localStorage.setItem(`digor-ai-widget`, JSON.stringify({ ...newState }));
  try {
    await dataCapsule.setItem(DIGOR_LS_KEY, JSON.stringify({ ...newState }), {
      category: 'functional',
    });
  } catch (ex) {
    cerr('digor-ai-widget:error-saving-state', ex);
  }
};

export const readStateFromLocalStorage = async <T>() => {
  // const state = localStorage.getItem(`digor-ai-widget`);
  let state: string | null = null;

  try {
    state = await dataCapsule.getItem(DIGOR_LS_KEY, {
      category: 'functional',
    });
  } catch (ex: any) {
    clog('digor-ai-widget:error-reading-state', {
      message: ex.message,
      DIGOR_LS_KEY,
    });
    return null;
  }

  if (!state) {
    return null;
  }

  let parsedState: T | null = null;
  try {
    parsedState = JSON.parse(state) as T;
  } catch (ex) {
    cerr('digor-ai-widget:error-parsing-state', ex);
    return null;
  }

  // if it's stale, discard it:
  if (state) {
    const savedAt = (parsedState as DIGORState)?.savedAt || 0;

    if (Date.now() - savedAt > STALE_AFTER) {
      resetState();
      return null;
    }
  }

  return parsedState;
};

export const resetState = () => {
  try {
    dataCapsule.removeItem(DIGOR_LS_KEY);
  } catch (ex) {
    cerr('digor-ai-widget:error-resetting-state', ex);
  }
};
